<template>
  <div class="accordion">
    <slot>
      <div class="item__box" v-for="(item, i) of list" :key="i">
        <div
            class="item__content"
            :class="[`item__content${i}`, { 'item__content-active': activeIndex === i }]"
        >
          <div class="item__content__detail">
            <img
                :src="item.src"
                alt=""
            />
            <div class="item">
              <div class="item_title">{{ item.title_1 }}</div>
              <div class="item_desc"><i class="el-icon-check"></i><div class="desc_text">{{ item.desc_1 }}</div></div>
              <div class="item_desc"><i class="el-icon-check"></i><div class="desc_text">{{ item.desc_2 }}</div></div>
              <div class="item_desc"><i class="el-icon-check"></i><div class="desc_text">{{ item.desc_3 }}</div></div>
              <div class="item_desc"><i class="el-icon-check"></i><div class="desc_text">{{ item.desc_4 }}</div></div>
              <div class="tag-area">
                <el-tag
                    v-for="(tagItem,index) in item.tags"
                    :key="index"
                    type="info"
                    size="mini"
                    class="tag"
                    effect="plain">
                  {{ tagItem }}
                </el-tag>
              </div>

              <div class="btn-more">
                <a href="/BusinessPartner" class="a1"><el-button type="primary" class="btn">立即咨询</el-button></a>
                <a :href="item.moreUrl" class="a2"><el-button class="btn">了解更多</el-button></a>
              </div>
            </div>
          </div>
        </div>
        <div
            class="item__title"
            :class="[`item__title${i}`, { 'item__title-active': activeIndex === i }]"
        >
          <div class="item__title__detail" @click="() => tabChange(i)">
            <img
                :src="item.src"
                alt=""
            />
            <slot :name="`item__title${i}`">
              <div class="item__title__detail__text item__title__detail_add">{{ item.title }}</div>
              <div class="item__title__detail__text item__title__detail_add1">{{ item.desc }}</div>
            </slot>
          </div>
        </div>
      </div>
    </slot>
  </div>
</template>
<script>
// import { reactive, toRefs, onBeforeMount, onMounted, ref } from 'vue'
// import { getImageUrl } from '@/untils/index'
export default {
  name: 'Accordion',
  data() {
    return {
      activeIndex: 0,
      list: [
        {
          // icon: 'icon/icon_edu_gk.png',
          // activeIcon: 'icon/icon_edu_gk_active.png',
          title: '企业资源计划管理',
          title_1: '企业资源计划管理（ERP）',
          desc: '制造业数字化转型的核心引擎 ',
          desc_1: '资源整合：打破部门信息孤岛，统一管理采购、生产、库存、销售等全链路数据',
          desc_2: '流程优化：通过标准化业务流程（如MRP物料需求计划、生产排程），提升效率并降低人工成本',
          desc_3: '决策支持：实时生成财务报表、生产进度看板等，为管理层提供精准数据支撑',
          desc_4: '智能化升级：支持与物联网（IoT）、大数据分析等技术结合，推动智能制造转型',
          src: require('@/assets/img/accordion/item1.jpg'),
          tags: ['客户关系管理','生产资料统计','库存管理','仓库管理','计划排产','供应商管理','物流跟踪','生产进度跟踪','产品质量管理'],
          moreUrl:"/Solutions/erp"
        },{
          // icon: 'icon/icon_edu_gk.png',
          // activeIcon: 'icon/icon_edu_gk_active.png',
          title: '高级计划排程系统',
          title_1: '高级计划排程系统（APS）',
          desc: '智能制造的核心决策引擎',
          desc_1: '生产优化中枢：解决多品种、小批量、短交期的复杂排产难题，提升设备利用率与订单交付准时率',
          desc_2: '资源调度大脑：动态平衡设备、人力、物料等资源，规避瓶颈并降低库存成本',
          desc_3: '敏捷响应枢纽：支持插单、设备故障等突发事件的快速重排，缩短响应时间至分钟级',
          desc_4: '战略决策支撑：结合AI预测与数字孪生技术，为产能规划、供应链协同提供数据依据',
          src: require('@/assets/img/accordion/item2.jpg'),
          tags: ['订单导入','预测校准','约束条件配置','动态数据同步','算法优化','多场景模拟','异常预警','闭环迭代 '],
          moreUrl:"/Solutions/aps"
        },

        {
          // icon: 'icon/icon_edu_nj.png',
          // activeIcon: 'icon/icon_edu_nj_active.png',
          title: '智能制造执行管理',
          title_1: '智能制造执行管理（MES）',
          desc: '车间级智能管控的神经中枢',
          desc_1: '透明化执行：实时采集设备、物料、人员数据，构建车间级“数字孪生”，消除黑箱操作',
          desc_2: '效率优化器：通过动态排程、异常预警与资源调度，提升设备OEE（综合效率）',
          desc_3: '质量追溯网：实现从原材料到成品的全流程质量追溯，缺陷定位时间大幅缩短',
          desc_4: '决策支持基座：基于生产大数据生成KPI分析（如产能利用率、准时交付率），驱动持续改进',
          src: require('@/assets/img/accordion/item3.jpg'),
          tags: ['订单拆解','动态排程','物料拉动','设备预检','工序协同','异常响应','在线检测','预测性维护','能耗管理','OEE看板'],
          moreUrl:"/Solutions/mes"
        },{
          // icon: 'icon/icon_edu_nb.png',
          // activeIcon: 'icon/icon_edu_nb_active.png',

          title: '数字化供应链管理',
          title_1: '数字化供应链管理（SCM）',
          desc: '全链路协同与敏捷响应的战略中枢 ',
          desc_1: '资源整合器：打通采购、生产、物流、销售数据孤岛，构建全局可视化视图',
          desc_2: '流程优化引擎：通过智能算法优化库存周转率、订单交付周期等核心指标，降低运营成本',
          desc_3: '风险防控盾牌：实时监控供应链中断风险（如供应商异常、物流延迟），生成应急预案',
          desc_4: '价值共创平台：推动供应商参与产品创新，实现从“成本博弈”到“生态共赢”的转型',
          src: require('@/assets/img/accordion/item4.jpg'),
          tags: ['需求计划','客户协同','智能寻源','JIT生产','动态路由规划','逆向物流','绩效看板'],
          moreUrl:"/Solutions/scm"
        }, {
          // icon: 'icon/icon_edu_nj.png',
          // activeIcon: 'icon/icon_edu_nj_active.png',
          title: '智能仓储管理',
          title_1: '智能仓储管理（WMS）',
          desc: '仓储智能化的调度中枢',
          desc_1: '库存精准化：实现库位级实时可视化管理，库存精确度实现了质的提升',
          desc_2: '作业高效化：通过智能策略（储位分配、路径规划）降低人工成本',
          desc_3: '自动化协同：无缝对接AGV、堆垛机、分拣机等设备，构建无人仓作业体系',
          desc_4: '合规可追溯：满足GMP/FDA/ISO等质量规范，支持批次/序列号全生命周期追溯',
          src: require('@/assets/img/accordion/item5.jpg'),
          tags: ['预约协同','策略上架','动态盘点','库位优化','智能分单','路径导航','防错校验','承运协同','逆向追溯'],
          moreUrl:"/Solutions/wms"
        }
      ]
    }
  },
  methods: {
    tabChange(index) {
      this.activeIndex = index
    }
  }
}
// interface Item {
//   icon?: string
//   activeIcon?: string
//   title: string
// }

// defineProps({
//   list: {
//     type: Array,
//     default: () => []
//   }
// })

</script>
<style lang="scss" scoped>
.accordion {

  position: relative;
  width: 70%;
  margin: auto;
  height: 520px;
  padding: 10px 0;
  display: flex;
  color: #fff;
  //background: url('@/assets/images/bg_shoufq.png');
  overflow: hidden;
}
.item__box {
  position: relative;
  display: flex;
  overflow: hidden;
  margin-left: 4px;
}
.item__content {
  flex-shrink: 0;
  width: 8px;
  left: 30%;
  overflow: hidden;
  border-radius: 4px;
  transition: all 0.5s ease;
  //box-shadow: 10px 10px 20px 2px rgba(12, 28, 56, 0.18);


}
.item__title {
  width: 210px;
  flex-shrink: 0;
  //background: #00398e;
  border-radius: 4px;
  //box-shadow: 10px 10px 12px 2px rgba(12, 28, 56, 0.18);

}
.item__content__detail {
  width: 420px;
  height: 500px;
  border-radius: 4px;
  opacity: 0;
  transition: opacity 0.5s ease;

}
.item__content-active {
  width: 420px;
  margin-left: 8px;
  border-radius: 4px;
  left: 0;border: 2px solid #fff;

  .item__content__detail {
    display: flex;
    width: 420px;
    opacity: 1;
    background-color: #fff;
    .item{
      padding: 30px 20px;position: relative;z-index: 1;height: 100%;
      .tag-area{
        text-align: left;padding-top: 50px;padding-left: 10px;
        .tag{
          margin: 4px;font-size: 12px
        }
      }
      .btn-more{
        position: absolute;
        bottom: 40px;
        align-items: center;
        display: flex;
        .a1{
          color: #fff;
          margin-right: 20px;
          .btn{
            background-color: #00A4FF;
            width: 170px;
            padding: 10px;
          }
        }
        .a2{
          color: #fff;
          .btn{
            width: 170px;
            padding: 10px
          }
        }
      }
    }

    img {
      position: absolute;
      width: 416px;
      height: calc(100% - 4px);
      border-radius: 4px;
      object-fit: cover; /* 或者使用contain, fill, none, scale-down等值 */
      object-position:80% 100%; /* 默认值，可以根据需要调整x和y坐标 */
      opacity: 0.4;
      z-index: 0;
    }
    .item_title {
      transition: all 0.5s;
      font-size: 22px;
      font-weight: bold;
      color: #05102F;
      text-align: left;
      padding: 10px 0 10px 0;
      z-index: 2;
      position: inherit;
      @media screen and (max-width: 768px) {
        font-size: 1rem;
        text-align: center;
      }
    }
    .item_desc {
      transition: all 0.5s;
      color: #666;
      text-align: left;
      line-height: 20px;
      z-index: 2;
      position: inherit;
      font-size: 12px;
      min-height: 34px;
      @media screen and (max-width: 768px) {
        min-height: 110PX;
        text-indent: 2em;
        font-size: 12px;
      }
      i{
        padding-right: 5px;
        color: #0052D9;
        font-weight: bold;
        float: left;
        margin-top: 5px;
      }
      .desc_text{
        margin-left: 22px;float: left;margin-top: -14px
      }

    }
  }
}

.item__title__detail {
  display: flex;
  flex-direction: column;

  //justify-content: center;
  //align-items:start;
  text-align: left;
  width: 100%;
  height: 500px;
  cursor: pointer;
  border-radius: 4px;

  img {
    position: absolute;
    width: 210px;
    height: 100%;
    border-radius: 4px;
    border: 2px solid #fff;
    object-fit: cover; /* 或者使用contain, fill, none, scale-down等值 */
    object-position:90% 100%; /* 默认值，可以根据需要调整x和y坐标 */
    z-index: 1;
  }

  &__text {
    padding: 0 15px;
    //writing-mode: vertical-lr;
    font-size: 22px;
    //font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 30px;
    z-index: 2;

  }
}
.item__title__detail_add{
  padding-top: 30px
}
.item__title__detail_add1{
  font-size: 0.7vw;font-weight: normal;padding-top: 10px;
}
.item__title-active {
  width: 0;
  //background: linear-gradient(180deg, #ffbb1a 0%, #f57c00 100%);
}

@keyframes moveInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

</style>

